export default "__VITE_ASSET__D1vVsfdW__"